document.addEventListener('DOMContentLoaded', function() {
    // Open location
    const areaBtn = document.getElementById('area');
    const areaBtnLong = document.getElementById('areaLong');
    const areaCloses = document.querySelectorAll('.area-close');
    const flyoutFooter = document.querySelector('.footer-location');
    const flyoutFooterLong = document.querySelector('.footer-locations-long');
    const bookingLocations = document.getElementById('bookingLocation');
    if (areaBtnLong) {
        areaBtnLong.addEventListener('click', function() {
            bookingLocations.classList.toggle('active');
            flyoutFooterLong.classList.toggle('opacity-50');
            flyoutFooterLong.classList.toggle('pointer-events-none');
        });
    }
    if (areaBtn) {
        areaBtn.addEventListener('click', function() {
            bookingLocations.classList.toggle('active');
            flyoutFooter.classList.toggle('opacity-50');
            flyoutFooter.classList.toggle('pointer-events-none');
        });
    }
    if (areaCloses) {
        areaCloses.forEach(function(areaClose) {
            areaClose.addEventListener('click', function() {
                bookingLocations.classList.remove('active');
                flyoutFooter.classList.remove(
                    'opacity-50',
                    'pointer-events-none',
                );
                flyoutFooterLong.classList.remove(
                    'opacity-50',
                    'pointer-events-none',
                );
            });
        });
    }

    // Add selected locations
    const checkboxes = document.querySelectorAll(
        '#bookingLocation input[type=\'checkbox\']');
    const selectedAreas = document.querySelectorAll('#selected-area');
    const selectedButton = document.querySelector('.area-selected');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateSelectedAreas);
    });

    function updateSelectedAreas() {
        let selectedTerms = [];

        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                const label = checkbox.closest('label');
                const termName = label.querySelector('strong')
                    .textContent
                    .trim();
                selectedTerms.push(termName);
            }
        });

        let newText = 'Hela Sverige';
        if (selectedTerms.length === 1) {
            newText = selectedTerms[0];
        } else if (selectedTerms.length > 1) {
            newText =
                `${selectedTerms[0]} och ${selectedTerms.length - 1} till`;
        }

        selectedAreas.forEach(el => el.value = newText);
        document.querySelector('#selected-areas-list').value =
            selectedTerms.join(', ');

        // Lägg till eller ta bort klass på knappen
        if (selectedTerms.length > 0) {
            selectedButton.classList.add(
                'bg-svmbronze',
                'opacity-100',
                'text-white',
            );
            selectedButton.classList.remove('bg-svmlightgold', 'opacity-30');
        } else {
            selectedButton.classList.remove(
                'bg-svmbronze',
                'opacity-100',
                'text-white',
            );
            selectedButton.classList.add('bg-svmlightgold', 'opacity-30');
        }
    }

    // Remover location overlay on scroll to bottom
    const container = document.querySelector('#bookingLocation .flyout__body');
    const overlay = document.querySelector('#bookingLocation .location-overlay');

    if (container && overlay) {
        container.addEventListener('scroll', function() {
            const isAtBottom = container.scrollTop +
                container.clientHeight >=
                container.scrollHeight -
                1;

            if (isAtBottom) {
                overlay.classList.add('active');
            } else {
                overlay.classList.remove('active');
            }
        });
    }

    // Reset tabb on close button click
    document.querySelector('[data-flyout="booking-request"] #closeFlyout')
        .addEventListener('click', () => {
            let tabContainer = document.getElementById('flyoutRequest');
            if (tabContainer) {
                tabContainer.dispatchEvent(new CustomEvent(
                    'reset-tab',
                    {bubbles: true},
                ));
            }
        });

    document.querySelector('[data-flyout="booking-help"] #closeFlyout')
        .addEventListener('click', (event) => {
            let flyout = event.target.closest('[data-flyout="booking-help"]');
            if (flyout) {
                let tabContainer = flyout.querySelector('[x-data]');
                if (tabContainer) {
                    tabContainer.dispatchEvent(new CustomEvent(
                        'reset-tab',
                        {bubbles: true},
                    ));
                }
            }
        });

    // Remove headline on thank you step
    const sendButtons = document.querySelectorAll('.btn-send');
    const closeButtons = document.querySelectorAll('.flyout-close');

    sendButtons.forEach(button => {
        button.addEventListener('click', function() {
            const flyout = document.querySelector(
                '[data-flyout="booking-request"] .flyout__header h2');
            if (flyout) {
                flyout.classList.add('hidden');
            }
        });
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', function() {
            const flyout = document.querySelector(
                '[data-flyout="booking-request"] .flyout__header h2');
            if (flyout) {
                flyout.classList.remove('hidden');
            }
        });
    });

    const closeButtonHelp = document.getElementById('helpClose');
    const exitButtonHelp = document.querySelector(
        '[data-flyout="booking-help"] .flyout-close');
    const sendButtonHelp = document.querySelector('.btn-send-help');
    const flyoutHelp = document.querySelector(
        '[data-flyout="booking-help"] .flyout__header h2');

    if (sendButtonHelp) {
        sendButtonHelp.addEventListener('click', function() {
            flyoutHelp.classList.add('hidden');
        });
    }

    if (closeButtonHelp) {
        closeButtonHelp.addEventListener('click', function() {
            flyoutHelp.classList.remove('hidden');
        });
    }

    if (exitButtonHelp) {
        exitButtonHelp.addEventListener('click', function() {
            flyoutHelp.classList.remove('hidden');
        });
    }

    // Open chatbox from imbox
    document.getElementById('openChatButton')
        .addEventListener('click', function() {
            imbox.open();
        });
    document.getElementById('openChatButtonRequest')
        .addEventListener('click', function() {
            imbox.open();
        });

});

//# sourceMappingURL=widget-request.js.map
